export default __webpack_public_path__ + "static/media/homenagem.de079718.pdf";